//抄表
export default [{
  //抄表系统-首页
  path: '/meterHome',
  name: 'meterHome',
  component: () =>
    import('@/page/system/meterReading/meterHome.vue')
},
{
  //抄表系统-电表管理
  path: '/meterManager',
  name: 'meterManager',
  component: () =>
    import('@/page/system/meterReading/meterManager.vue')
}, {
  //抄表系统-电表管理
  path: '/temp',
  name: 'temp',
  component: () =>
    import('@/page/system/meterReading/temp.vue')
},
{
  //抄表系统-水表管理
  path: '/waterManager',
  name: 'waterManager',
  component: () =>
    import('@/page/system/waterMeterReading/waterMeterManager.vue')
},
{
  //抄表系统-业主管理
  path: '/ownerManager',
  name: 'ownerManager',
  component: () =>
    import('@/page/system/meterReading/ownerManager.vue')
},
{
  //抄表系统-业主管理详情
  path: '/ownerManagerView',
  name: 'ownerManagerView',
  component: () =>
    import('@/page/system/meterReading/ownerManagerView.vue')
},

{
  //抄表系统-计费管理
  path: '/chargingManager',
  name: 'chargingManager',
  component: () =>
    import('@/page/system/meterReading/chargingManager.vue')
}, {
  //抄表系统-表配置
  path: '/meterSetting',
  name: 'meterSetting',
  component: () =>
    import('@/page/system/meterReading/meterSetting.vue')
}, {
  //抄表系统-看板
  path: '/meterOverview',
  name: 'meterOverview',
  component: () =>
    import('@/page/system/meterReading/meterOverview.vue')
}, {
  // 企业信息
  path: '/unitInformation',
  name: 'unitInformation',
  component: () =>
    import('@/page/system/meterReading/unitInformation.vue')
}, {
  // 默认参数
  path: '/defaultParamsManager',
  name: 'defaultParamsManager',
  component: () =>
    import('@/page/system/meterReading/defaultParamsManager.vue')
}, {
  // 单价设置
  path: '/priceConfiguration',
  name: 'priceConfiguration',
  component: () =>
    import('@/page/system/meterReading/priceConfiguration.vue')
}, {
  // 计费名称
  path: '/priceConfiguration1',
  name: 'priceConfiguration1',
  component: () =>
    import('@/page/system/meterReading/priceConfiguration1.vue')
}, {
  // 操作记录
  path: '/operateRecords',
  name: 'operateRecords',
  component: () =>
    import('@/page/system/meterReading/operateRecords.vue')
}, {
  //财务报表
  path: '/financeReport',
  name: 'financeReport',
  component: () =>
    import('@/page/report/financeReport2.vue')
}, {
  //财务报表
  path: '/financeReport2',
  name: 'financeReport2',
  component: () =>
    import('@/page/report/financeReport.vue')
}, {
  //new财务报表
  path: '/newFinanceReport',
  name: 'newFinanceReport',
  component: () =>
    import('@/page/report/newFinanceReport.vue')
}, {
  //抄表计量
  path: '/measurement',
  name: 'measurement',
  component: () =>
    import('@/page/report/measurement.vue')
}, {
  //销户管理
  path: '/cancellation',
  name: 'cancellation',
  component: () =>
    import('@/page/report/cancellation.vue')
}, {
  //电费账单
  path: '/electricityBill',
  name: 'electricityBill',
  component: () =>
    import('@/page/report/electricityBill.vue')
}, {
  //账单列表
  path: '/electricityList',
  name: 'electricityList',
  component: () =>
    import('@/page/report/electricityList.vue')
}, {
  //电费账单
  path: '/billReport',
  name: 'billReport',
  component: () =>
    import('@/page/report/billReport.vue')
},
{
  //充值管理
  path: '/rechargeManage',
  name: 'rechargeManage',
  component: () =>
    import('@/page/report/rechargeManage.vue')
},
{
  //现金充值
  path: '/rechargeDetail',
  name: 'rechargeDetail',
  component: () =>
    import('@/page/report/rechargeDetail.vue')
},
{
  //水费账单
  path: '/waterBillReport',
  name: 'waterBillReport',
  component: () =>
    import('@/page/system/waterMeterReading/waterBillReport.vue')
},
{
  //抄表系统-账单详情
  path: '/orderDetailListReport',
  name: 'orderDetailListReport',
  component: () =>
    import('@/page/report/orderDetailListReport.vue')
},
{
  //抄表系统-补扣记录
  path: '/makeupRecords',
  name: 'makeupRecords',
  component: () =>
    import('@/page/system/meterReading/makeupRecords.vue')
},
{
  //抄表系统-单价计费
  path: '/unitPrice',
  name: 'unitPrice',
  component: () =>
    import('@/page/system/meterReading/unitPrice.vue')
},
{
  //抄表系统-阶梯计费
  path: '/ladder',
  name: 'ladder',
  component: () =>
    import('@/page/system/meterReading/ladder.vue')
},
{
  //抄表系统-模板配置
  path: '/templateConfiguration',
  name: 'templateConfiguration',
  component: () =>
    import('@/page/system/meterReading/templateConfiguration.vue')
},
{
  //抄表系统-模板应用
  path: '/templateApplication',
  name: 'templateApplication',
  component: () =>
    import('@/page/system/meterReading/templateApplication.vue')
}

]